<template>
  <div class="edit">
    <div>审批通过后，员工状态将在转正日期后变为正式员工</div>
  </div>
</template>

<script>
export default {
  props: {
    editForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {
    batchClick() {
      this.$emit("batchClick");
    },
    addSelect() {
      this.$emit("addSelect");
    },
    removeSelect() {
      this.$emit("removeSelect");
    },
  },
};
</script>

<style lang="scss" scoped>
.draggable-none {
  // margin: 42px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 42px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  color: #999999;
  img {
    margin-right: 16px;
  }
}
.edit-none {
  height: 100%;
  color: #999999;
  position: relative;
  span {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.edit-number {
  width: 100%;
  line-height: 40px;
  background-color: #ffeeee;
  color: #d43030;
  font-size: 12px;
  text-align: center;
  margin-bottom: 16px;
}
.edit-title {
  color: #0f66f2;
  margin-bottom: 24px;
  .iconfont {
    margin-right: 8px;
  }
}
.edit-column {
  text-align: center;
  margin: 35% 0 0;
  color: #999999;
  div {
    line-height: 36px;
  }
}
.addedit {
  padding: 12px 0;
  color: #0f66f2;
  span {
    padding: 0 8px;
    cursor: pointer;
    &:nth-of-type(1) {
      border-right: 1px solid #eeeeee;
    }
  }
}
.edit-item {
  margin-bottom: 16px;
  .title {
    margin-bottom: 12px;
    span {
      font-size: 12px;
      color: #999;
    }
    i {
      font-style: normal;
      color: #0f66f2;
    }
  }
}
.edit-item2 {
  margin-bottom: 12px;
}
.edit-have {
  height: 100%;
}
.edit-item-list {
  margin-bottom: 8px;
}
.edit-ul {
  width: 80%;
  margin: 16px auto;
  li {
    display: flex;
    padding: 6px;
    border: 1px solid #eeeeee;
    div {
      width: 50%;
      text-align: center;
      &:nth-of-type(1) {
        border-right: 1px solid #eeeeee;
      }
    }
  }
}
</style>
